import { PREFERENCE } from 'store/store.constants';

const selectPreferenceSlice = (state) => state[PREFERENCE];
export const selectAppearance = (state) => selectPreferenceSlice(state).appearance;
